// 카피바라 머리 위 말풍선 (8글자 채팅·NPC 말). 프로토타입 say 2522–2527, 위치 맞추기 tick 4062–4069, CSS 72–73.
// 허용 글자 검사는 packages/shared/src/chat.ts (말하는 쪽에서 한다).
import * as THREE from 'three';
import type { Capy } from '../capy/agent';

interface Bubble { el: HTMLDivElement; until: number }

export interface Speech {
  say(a: Capy, text: string, t: number): void;
  /** 한 방의 말풍선을 모두 숨긴다 (방을 떠날 때). */
  hide(list: readonly Capy[]): void;
  /** 매 프레임: 말풍선을 머리 위에 맞추고, 시간이 지나면 흐리게 지운다. */
  update(t: number, list: readonly Capy[], camera: THREE.Camera, host: HTMLElement): void;
}

/** 이름표·말풍선이 뜨는 높이 (아기는 낮게, 누우면 더 낮게). 프로토타입 labelH 1632. */
export const labelH = (a: Capy): number =>
  3.25 * ((a.size || 1) < 1 ? 0.64 : 1) * (1 - 0.55 * (a.lieAmt || 0)) + (a.seatLiftV || 0) + (a.bounceY || 0) + (a.elevY || 0);

export function createSpeech(host: HTMLElement): Speech {
  const bubbles = new WeakMap<Capy, Bubble>(), tmp = new THREE.Vector3();
  return {
    say(a, text, t) {
      let b = bubbles.get(a);
      if (!b) {
        const el = document.createElement('div'); el.className = 'speech'; el.setAttribute('aria-hidden', 'true'); host.appendChild(el);
        b = { el, until: 0 }; bubbles.set(a, b);
      }
      b.el.textContent = text; b.until = t + 4 + text.length * 0.08; b.el.style.display = 'block'; b.el.style.opacity = '1';
    },
    hide(list) { list.forEach((a) => { const b = bubbles.get(a); if (b) b.el.style.display = 'none'; }); },
    update(t, list, camera, view) {
      for (const a of list) {
        const b = bubbles.get(a);
        if (!b || b.el.style.display === 'none') continue;
        if (t > b.until + 0.4 || !a.c.root.visible) { b.el.style.display = 'none'; continue; }
        b.el.style.opacity = t > b.until ? '0' : '1';
        tmp.copy(a.c.root.position); tmp.y += labelH(a); tmp.project(camera);
        if (tmp.z > 1) { b.el.style.display = 'none'; continue; }
        b.el.style.transform = 'translate3d(' + ((tmp.x + 1) / 2 * view.clientWidth).toFixed(1) + 'px,' + ((1 - tmp.y) / 2 * view.clientHeight).toFixed(1) + 'px,0) translate(-50%,calc(-100% - ' + (a.isPlayer ? 40 : 8) + 'px))';
      }
    },
  };
}
